var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-input',_vm._b({attrs:{"value":_vm.value,"disabled":_vm.disabled},on:{"blur":_vm.onBlur,"change":_vm.onChange}},'a-input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }